// extracted by mini-css-extract-plugin
export default {"continuemodify_btn":"ContinueModifyBtn_continuemodify_btn__GwKOI","continuemodify_title":"ContinueModifyBtn_continuemodify_title__ofLd4"};